const musicLinkUrlPartsPT = {
    "view": {
        "table": {
            "title": "Sua lista de partes de URL de links de música",
            "column": {
                "part": "Parte",
                "owner": "Proprietário",
                "action": "Ação"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "exportCSV": "Exportar CSV"
            }
        },
        "message": {
            "success": "Parte de URL de Link de Música foi removida!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "noUrlparts": "Atualmente, este recurso é oferecido apenas para alguns usuários selecionados, mas a boa notícia é que você também poderá usá-lo em breve. Continue acompanhando este espaço!"
        },
        "modal": {
            "delete": {
                "header": "Excluir {{mlUrlpart}}?",
                "body": "Tem certeza de que deseja excluir esta parte de URL de link de música?"
            },
            "canNotDelete": {
                "header": "Não é possível excluir a parte de URL de link de música {{mlUrlPart}}",
                "body": "A parte de URL de link de música {{mlUrlPart}} não pode ser excluída, pois já está associada a um Link de Música."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Sub-Usuário",
                "part": "Parte",
                "owner": "Proprietário",
                "addUrlPart": "Adicionar Parte de URL",
                "editUrlPart": "Editar Parte de URL"
            },
            "placeholder": {
                "subUser": "Selecionar Sub-usuário..."
            },
            "help_text": {
                "subUser": "Nota: Use este menu suspenso apenas se você quiser adicionar um Link de Música para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado."
            },
            "button": {
                "reset": "Redefinir",
                "submit": "Enviar"
            },
            "validation": {
                "part": {
                    "required": "Parte é obrigatória",
                    "max": "Deve ter exatamente 16 caracteres"
                }
            },
            "message": {
                "subUserLimit": "Este sub-usuário atingiu o limite máximo de 10 partes de URLs.",
                "urlPartAlreadyTaken": "Este URL de Link de Música já está sendo usado por sua conta ou por outra conta de usuário. Por favor, tente algo diferente."
            }
        },
        "message": {
            "addSuccess": "Parte de URL de link de música foi adicionada!",
            "updateSuccess": "Parte de URL de link de música foi atualizada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    }
};

export default musicLinkUrlPartsPT;